import React from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Calendar, Clock, Globe } from "lucide-react";
import { format } from "date-fns";

export function ConfirmationScreen({ slot, details, categoryInfo }) {
    return (
        <div className="text-center space-y-8 max-w-md mx-auto p-0">
            <div className="justify-center" style={{textAlign: 'center'}}>
                <i className="pi pi-check-circle text-green-600 text-5xl"></i>
            </div>
            <h2 className="text-2xl font-bold text-blue-900">Booking Confirmed!</h2>

            <div className="relative mb-4">
                <img style={{width:'200px', margin: 'auto'}}
                    src="https://png.pngtree.com/png-clipart/20231105/original/pngtree-female-call-centre-executive-professional-picture-image_13233280.png"
                    alt="Professional advisor"
                    className="h-48 object-cover"
                />
            </div>

            <Card className="p-card p-card-primary p-p-6">
                {!categoryInfo?.skip_slot && 
                <div className="text-left text-sm space-y-3">
                    <p className="flex items-center gap-2">
                        <Calendar className="p-text-blue-600" />
                        <span className="text-gray-600">Date:</span>
                        <span className="font-medium">{format(slot.date, "EEEE, MMMM d, yyyy")}</span>
                    </p>
                    <p className="flex items-center gap-2">
                        <Clock className="p-text-blue-600" />
                        <span className="text-gray-600">Time:</span>
                        <span className="font-medium">{slot.time}</span>
                    </p>
                    <p className="flex items-center gap-2">
                        <Globe className="p-text-blue-600" />
                        <span className="text-gray-600">Timezone:</span>
                        <span className="font-medium">{slot.timezone}</span>
                    </p>
                </div>
                }
                <p className="text-gray-600 mt-4">
                    Thank you <span className="font-medium">{details.name}</span>, for booking a call with us. 
                    {!categoryInfo?.skip_slot && 
                        <>
                            A calendar invitation has been sent to your email.
                        </>
                    }
                </p>
            </Card>
        </div>
    );
}
